import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import Button from 'components/Button';
import InputPhoto from 'components/InputPhoto/mobile';
import Select from 'components/Selectors/Select/mobile';

import useCreateBonusGift from '../../../../model/useCreateBonusGift';

import './GiftEditor.scss';

const b = block('gift-editor-desktop');

const GiftEditor = () => {
  const locale = useSelector(s => s.locale.locale);
  const { values, handlers } = useCreateBonusGift();

  return (
    <form className={b()} onSubmit={handlers.handleSaveClick}>
      <div className={b('item')}>
        <div className={b('item-label')}>{locale.nameGift}</div>
        <div className={b('item-field')}>
          <Input
            value={values.state.name}
            onChange={e => handlers.handleNameChange(e.currentTarget.value)}
            placeholder={locale.nameGift}
          />
        </div>
      </div>

      <div className={b('item')}>
        <div className={b('item-label')}>{locale.numberOfPoints}</div>
        <div className={b('item-field')}>
          <Input
            value={values.state.points}
            onChange={e => handlers.handlePointsChange(e.currentTarget.value)}
            placeholder="0"
          />
        </div>
      </div>

      <div className={b('item')}>
        <div className={b('item-label')}>{locale.status}</div>
        <div className={b('item-field')}>
          <Select
            locale={locale}
            items={values.state.statusItems}
            onChange={v => handlers.handleStatusChange(v)}
            color="bonus"
          />
        </div>
      </div>

      <div className={b('item')}>
        <div className={b('item-label')}>{locale.promocodeAmount}</div>
        <div className={b('item-field')}>
          <Input
            value={values.state.promocodeOrAmount}
            onChange={e => handlers.handlePromocodeOrAmountChange(e.currentTarget.value)}
            placeholder="0"
          />
        </div>
      </div>

      <div className={b('item')}>
        <div className={b('item-label')}>{locale.image}</div>
        <div className={b('item-field')}>
          <InputPhoto
            key={values.id}
            currentImageData={values.state.imageData}
            onImageChange={handlers.handleImageDataChange}
            url={values.state.imageUrl}
          />
        </div>
      </div>

      <div className={b('item')}>
        <div className={b('item-label')}>{locale.playerLevel}</div>
        <div className={b('item-field')}>
          <Select
            locale={locale}
            items={values.state.levelItems}
            onChange={v => handlers.handleLevelItemsChange(v)}
            color="bonus"
          />
        </div>
      </div>

      <div className={b('item')}>
        <div className={b('item-label')}>{locale.typeOfPrize}</div>
        <div className={b('item-field')}>
          <Select
            locale={locale}
            items={values.state.typeItems}
            onChange={v => handlers.handleTypeItemsChange(v)}
            color="bonus"
          />
        </div>
      </div>

      <div className={b('row')}>
        <div className={b('button')}>
          <Button text={locale.cancel} type="button" callBack={handlers.handleCancelClick} color="transparent" />
        </div>

        <div className={b('button', { type: 'save' })}>
          <Button type="submit" disabled={values.disabled}>{values.buttonText}</Button>
        </div>
      </div>
    </form>
  );
};

export default GiftEditor;
